import styled from "styled-components";
import { media } from "../../theme/theme";
import { V3BodyGrey35 } from "../ReusableStyledComponents/V3BodyGrey35";
import { V3Body, V3HeadlineH1 } from "../Typography";
import { ClampMixin, ClampMixinType } from "../ReusableStyledComponents/ClampMixin";

const HERO_BREAKPOINT = 960;

export const BlogHeroComponentWrapperCard = styled.div<{ postPage: boolean }>`
    border-radius: 23px 23px 12px 12px;
    padding: ${({ postPage }) => postPage ? "0px" : "12px"};
    background: white;
    max-width: 1400px;
    flex-direction: column;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: space-between;

    a {
        text-decoration: none;
    }

    ${media.custom(HERO_BREAKPOINT)} {
        flex-direction: row;
        padding: ${({ postPage }) => postPage ? "0px" : "20px"};
        border-radius: 32px;
    }

    ${media.custom(1200)} {
        padding: ${({ postPage }) => postPage ? "0px" : "36px"};
    }

    > div {
        width: 100%;

        ${media.custom(HERO_BREAKPOINT)} {
            width: calc(50% - 12px);
        }

        &:first-child {
            ${media.custom(HERO_BREAKPOINT)} {
                padding-right: ${({ postPage }) => postPage ? "70px" : "40px"};
            }
        }

        &:nth-child(2){
            order: -1;
            margin-bottom: 24px;
            max-width: 480px;

            ${media.custom(HERO_BREAKPOINT)} {
                max-width: initial;
                flex-shrink: 0;
                min-width: 350px;
                order: initial;
                margin-bottom: 0;
            }
        }
    }
`;

export const BlogHeroComponentTag = styled.div`
    background: ${({ theme }) => theme.v3.colors.lightBlue};
    padding: 4px 10px;
    border-radius: 16px;
    text-transform: uppercase;
    display: inline-block;

    ${V3Body} {
        color: ${({ theme }) => theme.v3.colors.blue};
    }
`;

export const BlogHeroTagReadingTime = styled.div`
    display: flex;
    align-items: center;

    > div {
        &:first-child {
            margin-right: 16px;
        }
    }
`;

export const BlogArticleReadingTime = styled(V3Body)`
    color: ${({ theme }) => theme.v3.colors.blue};
    font-weight: 500;
`;

export const BlogHeroShortTitle = styled(V3HeadlineH1)`
    font-size: 26px;
    line-height: 33px;

    ${media.tablet} {
        font-size: 38px;
        line-height: 120%;
    }
`;

export const BlogHeroLongTitle = styled(V3HeadlineH1)`
    font-size: 26px;
    line-height: 33px;

    ${media.tablet} {
        font-size: 38px;
        line-height: 48px;
    }
`;

export const BlogHeroExcerpt = styled(V3BodyGrey35) <ClampMixinType>`
    font-size: 18px;
    line-height: 29px;
    ${ClampMixin}
`;

export const BlogHeroVideoIframe = styled.div`
    height: 0;
    overflow: hidden;
    padding-bottom: 56.25%;
    position: relative;
    width: 100%;
    position: relative;
    z-index: 1;
    border-radius: 16px;
`;

export const BlogHeroYTHPIframe = styled.iframe`
    height: 100%;
    left: 0;
    position: absolute;
    top: 0;
    width: 100%;
`;
